import { Link } from 'gatsby';
import type { FC } from 'react';
import type { Discover } from '../../../@types/gql/home';
import OpacitySlideIn from '../../animation/opacity-slide-in';
import BannerImgTwo from '../../../images/img.png';

const HomeDiscoverSection: FC<Discover> = ({
  //ContentBlock1,
  ContentBlock2,
  HighlightedText,
  Title,
  Stats,
}) => {
  return (
    <section>
      <section className='py-10' style={{
      backgroundImage: `url(${BannerImgTwo})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      height: 'auto',
    }}>
      <div className="about-feature-area">
        <div className="circle-drop-shadow"/>
          <div className='container m-auto'>
            <div className='text-gray-50 max-w-6xl mx-auto text-center'>
            <h3 className="text-5xl leading-snug font-bold whitespace-pre-wrap max-lg:text-3xl md:px-14">
                    <span>{Title}</span>
                    <span className="bg-action-btn bg-clip-text text-transparent">
                      {HighlightedText}
                    </span>
                  </h3>
                  <p
                    className="font-light text-base  text-center-500 leading-7 my-5 line-clamp-4"
                    title={ContentBlock2.Description}
                  >
                    {ContentBlock2.Description}
                  </p>
                  <Link
                    className="bg-action-btn2 py-2 my-5 inline-block px-4 space-x-2 items-center text-lg
            transition-smooth hover:scale-105 hover:-translate-y-1 hover:shadow-lg w-fit rounded-lg max-lg:text-sm"
                    to="/about/"
                  >
                    <span>ABOUT US</span>
                  </Link>
                  
            </div>
            <div className="grid md:grid-cols-3 gap-5 items-center 
               text-center mt-9">
                 {Stats?.map(({ Info, Number, id }) => (
                  <div className='te-info-card style-2 !py-12'>
                  <div className='te-info-card-inner'>
                  <div className="te-content-wrapper">
                  <div
                      className="text-gray-50 border-r border-white max-md:border-none border-solid w-full last:border-none bg-action-btn bg-clip-text text-transparent"
                      key={id}
                    >
                      <p className="text-6xl font-bold max-sm:text-4xl">
                        {Number}
                      </p>
                      <p className="whitespace-pre-wrap font-semibold font-light mt-1.5 text-xl">
                        {Info}
                      </p>
                    </div>
                            </div>
                  </div>
                  </div>
                 ))}
               
          </div>
          </div>

   
       
      </div>
      </section>
      <div className="mx-auto">
        <div className="grid grid-cols-1 lg:gap-x-6 lg:gap-y-0 gap-y-6 items-center">
          {/* jfhkdhkjfhkjd */}
          {/* <div className="relative text-center item-center">
            <div className="absolute left-0 top-0 bottom-0 right-0">
              <img
                alt=""
                className="h-full w-full"
                loading="lazy"
                src={BannerImgTwo}
              />
            </div>
            <div className="z-10 relative">
              <div className="py-20 pt-28 container px-6 mx-auto">
                <div className="text-gray-50 max-w-3xl mx-auto">
                  <h3 className="text-5xl leading-snug font-bold whitespace-pre-wrap max-lg:text-3xl">
                    <span>{Title}</span>
                    <span className="bg-action-btn bg-clip-text text-transparent">
                      {HighlightedText}
                    </span>
                  </h3>
                  <p
                    className="font-light text-base font-normal text-center-500 leading-7 my-5 line-clamp-4"
                    title={ContentBlock2.Description}
                  >
                    {ContentBlock2.Description}
                  </p>
                  <Link
                    className="bg-action-btn2 py-2 my-5 inline-block px-4 space-x-2 items-center text-lg
            transition-smooth hover:scale-105 hover:-translate-y-1 hover:shadow-lg w-fit rounded-lg max-lg:text-sm"
                    to="/about/"
                  >
                    <span>ABOUT US</span>
                  </Link>
                </div>
              </div>
              <OpacitySlideIn
                className="lg:col-span-2 h-full lg:pt-6"
                delay={0.3}
                slideFrom={{ x: 0, y: 20 }}
              >
                <div
                  className="grid md:grid-cols-3  gap-4 p-6 bg-action-btn2 rounded-sm h-full items-center 
              md:justify-items-center text-center"
                >
                  {Stats?.map(({ Info, Number, id }) => (
                    <div
                      className="text-gray-50 border-r border-white max-md:border-none border-solid w-full last:border-none"
                      key={id}
                    >
                      <p className="text-6xl font-bold max-sm:text-4xl">
                        {Number}
                      </p>
                      <p className="whitespace-pre-wrap font-semibold font-light mt-1.5 text-xl">
                        {Info}
                      </p>
                    </div>
                  ))}
                </div>
              </OpacitySlideIn>
            </div>
          </div> */}
          {/* hkdghgfhdfdhfkjh */}
          {/* <OpacitySlideIn slideFrom={{ x: 0, y: 20 }}>
            <h3 className="text-3xl font-semibold whitespace-pre-wrap">
              <span>{Title}</span>
              <span className="bg-action-btn bg-clip-text text-transparent">
                {HighlightedText}
              </span>
            </h3>
          </OpacitySlideIn> */}
          {/* Founded */}
          {/* <OpacitySlideIn
            className="lg:col-span-2"
            delay={0.1}
            slideFrom={{ x: 0, y: 20 }}
          >
            <div className="bg-white shadow-md lg:p-10 p-6 rounded-sm">
              <p className="text-lg font-medium">{ContentBlock1.Title}</p>
              <p
                className="font-light text-gray-500 my-4 line-clamp-4"
                title={ContentBlock1.Description}
              >
                {ContentBlock1.Description}
              </p>

              <Link
                className="flex space-x-1 items-center transition-smooth hover:-translate-y-1"
                to={ContentBlock1.RedirectURL}
              >
                <span className="bg-action-btn bg-clip-text text-transparent text-sm uppercase">
                  Read More
                </span>
                <SVGGradientFiller
                  id="read-more-icon"
                  stop={{ from: '#990400', via: '#FF3D00', to: '#FF8A00' }}
                />
                <BsArrowRight
                  className="mt-px"
                  style={{ fill: 'url(#read-more-icon)' }}
                />
              </Link>
            </div>
          </OpacitySlideIn> */}

          {/* Our Mission */}
          {/* <OpacitySlideIn delay={0.2} slideFrom={{ x: 0, y: 20 }}>
            <div className="bg-white/90 rounded-sm p-6 shadow-md">
              <p className="text-lg font-medium">{ContentBlock2.Title}</p>
              <p
                className="font-light text-gray-500 my-5 line-clamp-4"
                title={ContentBlock2.Description}
              >
                {ContentBlock2.Description}
              </p>

              <Link
                className="flex space-x-1 items-center transition-smooth hover:-translate-y-1"
                to={ContentBlock2.RedirectURL}
              >
                <span className="bg-action-btn bg-clip-text text-transparent text-sm uppercase">
                  Read More
                </span>
                <SVGGradientFiller
                  id="read-more-icon"
                  stop={{ from: '#990400', via: '#FF3D00', to: '#FF8A00' }}
                />
                <BsArrowRight
                  className="mt-px"
                  style={{ fill: 'url(#read-more-icon)' }}
                />
              </Link>
            </div>
          </OpacitySlideIn> */}

          {/* Stats */}
          {/* <OpacitySlideIn
            className="lg:col-span-2 h-full lg:pt-6"
            delay={0.3}
            slideFrom={{ x: 0, y: 20 }}
          >
            <div
              className="grid md:grid-cols-3  gap-4 p-6 bg-action-btn rounded-sm h-full items-center 
              md:justify-items-center text-center"
            >
              {Stats?.map(({ Info, Number, id }) => (
                <div className="text-gray-50" key={id}>
                  <p className="text-4xl font-semibold">{Number}</p>
                  <p className="whitespace-pre-wrap font-light mt-1.5 text-sm">
                    {Info}
                  </p>
                </div>
              ))}
            </div>
          </OpacitySlideIn> */}
        </div>
      </div>
    </section>
  );
};

export default HomeDiscoverSection;
